module.exports = __webpack_public_path__ + "components/weather-icon/static/nightpartcloud@3-2b95b3e72f38498c86de587fe7616dae.png";